<template>
    <MainPage @clickBack="gotoMain()">
        <template v-slot:header>
            <div class="header-title">
                {{ lbl.side_menu.fag }}
            </div>
        </template>
        <div class="faq-container">
            <div class="content-height custom-scrollbar" v-if="faqList.length > 0">
                <FaqList
                :list="faqList"
                />
            </div>
            <div v-else class="not-fount">
                <img src="@/assets/icon/ic-not-fount-faq-dark.svg" alt="">
                <div class="text-not-found">ไม่มีข้อมูล</div>
            </div>
        </div>
    </MainPage>
</template>

<script>
// component
import MainPage from '@/components/Layout/Page/MainPage.vue';
// service
import FaqBlob from '../service/FaqBlob'
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import FaqList from '../component/FaqList.vue';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "Faq",
    mixins: [ModalMixin , LocaleMixin],
    components: {
        MainPage,
        FaqList
    },
    data: function () {
        return {
            faqList: [],
            loadingModal: null,
        }
    },
    created:async function () {
        await this.getFaqBlob();
    },
    methods: {
        gotoMain: function() {
            this.$router.back()
        },
        getFaqBlob: function () {
            this.loadingModal.show();
            return new Promise((resolve, reject) => {
                FaqBlob.getBlobFaq(this.localeCode)
                    .then((res) => {
                        this.faqList = res.data;
                        this.loadingModal.hide();
                        resolve(true);
                    })
                    .catch(err => {
                        console.log(err);
                        this.loadingModal.hide();
                        reject(false);
                    });
                })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../style/Faq.scss";
    @import "@/style/base/baseDisplay.scss";
    @import "@/style/base/baseUtility.scss";
    @import "@/style/base/base.scss";

    .faq-container {
        background-color: #fff;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 30px 48px;
        border-radius: 5px;
        max-height: calc(847px - 56px);
    }

    .content-height {
        overflow-y: auto;
        height: 100%;
        &.custom-scrollbar{
            @include scrollbar($a-gray-999999, $a-gray-cdcdcd)
        }
    }
</style>
